// src/components/Footer/Footer.jsx
import React from "react";
import Logo from "../assets/logo.png";
import { Link } from "react-router-dom";
import { FaFacebook, FaYoutube } from "react-icons/fa";

const Footer = () => {
  const navLinks = [
    { label: "Home", path: "/" },
    { label: "Products", path: "/products" },
    { label: "Our Projects", path: "/projects" },
    { label: "Gallery", path: "/gallery" },
    { label: "Contact Us", path: "/contact" },
  ];

  return (
    <footer className="relative bg-[#0b2a1f] text-gray-200 font-body overflow-hidden">
      {/* subtle top glow */}
      <div className="absolute inset-x-0 -top-20 h-40 bg-gradient-to-r from-green-400/10 via-transparent to-green-400/10 blur-2xl" />

      <div className="relative max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 py-12 sm:py-16">
        {/* Top Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-10 sm:gap-x-10 sm:gap-y-14">
          {/* Brand */}
          <div className="space-y-4 sm:space-y-5">
            <div className="flex items-center gap-3">
              <img
                src={Logo}
                alt="CheLinko Logo"
                className="w-10 h-10 sm:w-12 sm:h-12 object-contain drop-shadow-lg"
              />
              <h2 className="text-2xl font-semibold bg-gradient-to-r from-green-700 to-green-300 bg-clip-text text-transparent tracking-wide">
                CHELINKO
              </h2>
            </div>

            <p className="text-xs sm:text-sm text-gray-400 leading-relaxed">
              Premium stainless steel fabrication and industrial solutions in
              Sri Lanka, delivering precision, durability, and engineering
              excellence.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h5 className="text-gray-500 text-xs sm:text-sm font-semibold tracking-widest mb-4 sm:mb-6">
              QUICK LINKS
            </h5>

            <ul className="space-y-2 sm:space-y-3 text-xs sm:text-sm">
              {navLinks.map((link, idx) => (
                <li key={idx}>
                  <Link
                    to={link.path}
                    className="group inline-flex items-center gap-2 text-gray-300 transition-all duration-300 hover:text-green-400"
                  >
                    <span className="h-[1px] w-0 bg-green-400 transition-all duration-300 group-hover:w-4" />
                    <span className="group-hover:translate-x-1 transition-transform duration-300">
                      {link.label}
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h5 className="text-gray-500 text-xs sm:text-sm font-semibold tracking-widest mb-4 sm:mb-6">
              CONTACT
            </h5>

            <div className="space-y-2 sm:space-y-4 text-xs sm:text-sm">
              <a
                href="tel:+94772516056"
                className="flex items-center gap-2 text-gray-300 hover:text-green-400 transition-all"
              >
                <span className="material-symbols-outlined text-sm opacity-70">
                  call
                </span>
                +94 77 251 6056
              </a>

              <a
                href="tel:+94717551836"
                className="flex items-center gap-2 text-gray-300 hover:text-green-400 transition-all"
              >
                <span className="material-symbols-outlined text-sm opacity-70">
                  call
                </span>
                +94 71 755 1836
              </a>

              <a
                href="https://wa.me/94772516056"
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2 text-gray-300 hover:text-green-400 transition-all"
              >
                <span className="material-symbols-outlined text-sm opacity-70">
                  chat
                </span>
                WhatsApp 01
              </a>

              <a
                href="https://wa.me/94717551836"
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2 text-gray-300 hover:text-green-400 transition-all"
              >
                <span className="material-symbols-outlined text-sm opacity-70">
                  chat
                </span>
                WhatsApp 02
              </a>

              <a
                href="mailto:chelinkoss@gmail.com"
                className="flex items-center gap-2 text-gray-300 hover:text-green-400 transition-all"
              >
                <span className="material-symbols-outlined text-sm opacity-70">
                  mail
                </span>
                chelinkoss@gmail.com
              </a>
            </div>
          </div>

          {/* Headquarters */}
          <div>
            <h5 className="text-gray-500 text-xs sm:text-sm font-semibold tracking-widest mb-4 sm:mb-6">
              HEADQUARTERS
            </h5>

            <div className="space-y-1 sm:space-y-2 text-xs sm:text-sm text-gray-300">
              <p>103/A, Kottawa Rd</p>
              <p>Athurugiriya, Sri Lanka</p>

              <div className="pt-3 sm:pt-4">
                <h5 className="text-gray-500 text-xs sm:text-sm font-semibold tracking-widest mb-1 sm:mb-2">
                  FACILITY ACCESS
                </h5>
                <p>Mon – Fri: 8am – 5pm</p>
              </div>

              {/* Social Media */}
              <div className="pt-3 sm:pt-4">
                <h5 className="text-gray-500 text-xs sm:text-sm font-semibold tracking-widest mb-2">
                  SOCIAL MEDIA
                </h5>

                <div className="flex items-center gap-4">
                  <a
                    href="https://www.facebook.com/share/14bXfgcp8hZ/"
                    target="_blank"
                    rel="noreferrer"
                    className="text-gray-300 hover:text-green-400 transition"
                  >
                    <FaFacebook size={20} />
                  </a>

                  <a
                    href="https://www.youtube.com/@chelinkostainlesssteel6207"
                    target="_blank"
                    rel="noreferrer"
                    className="text-gray-300 hover:text-green-400 transition"
                  >
                    <FaYoutube size={20} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="my-10 sm:my-14 h-px w-full bg-gradient-to-r from-transparent via-green-400/40 to-transparent" />

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-2 sm:gap-4 text-[9px] sm:text-[11px] tracking-wider text-gray-500">
          <p>© 2026 CheLinko. All Rights Reserved.</p>

          <p className="hidden sm:block">
            Designed by{" "}
            <a
              href="https://isivara.dev"
              target="_blank"
              rel="noopener noreferrer"
              className="text-green-400 hover:text-green-300 transition-colors"
            >
              isivara.dev
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
